import React, { useState } from 'react'
import Main from '../cpn/Main'
import { Button, DatePicker, Form, Input,App } from 'antd'
import MyEditor from '../cpn/MyEditor'
import GetUser from '../cpn/GetUser'
import { useRenwuAddMutation } from '../store/BnsKeJiApi'
import dayjs from 'dayjs'
function TaskAdd() {
    const {message} = App.useApp()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [add] = useRenwuAddMutation()
    const [info,setInfo] = useState({
        rw_content:'',
        rw_dept_id:'196',
        rw_e_id:'218',
        rw_end_date:'',
        rw_fb_uid:eu_id,
        rw_fb_uname:eu_name,
        rw_js_uid:'',
        rw_js_uname:'',
        rw_name:'',
        rw_state:'1',
        rw_uid:eu_id,
        rw_uname:eu_name,
    })
    return (
        <Main selectedKeys={['/TaskAdd']}>
            <Form
                labelCol={{span:"5"}}
                wrapperCol={{span:'10'}}
                onFinish={() => {
                    add(info).then((res) => {
                                if (res.data.Status === 'success') {
                                    message.info('新增成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('新增失败！'+res.data.Message)
                                }
                            })   
                }}
            >
                <Form.Item
                    label='任务标题'
                    name='rw_name'
                >
                    <Input
                        onChange={(e) => {setInfo(prev => ({...prev,rw_name:e.target.value}))}}
                    />
                </Form.Item>
                <Form.Item
                    label='任务正文'
                    name='rw_content'
                >
                    <MyEditor 
                        height='400px'
                        onChange={(e) => {setInfo(prev => ({...prev,rw_content:e}))}}
                    />
                </Form.Item>
                <GetUser
                    label='执行人'
                    getUser={(e,f) => {
                        console.log(e,f);                        
                        setInfo(prev => ({...prev,rw_js_uid:e,rw_js_uname:f}))
                    }}
                    wrapperCol={{span:'4'}}
                    name='rw_fb_uname'

                />
                <Form.Item
                    label='截止日期'
                    name='rw_end_date'
                >
                    <DatePicker
                         onChange={(e) => {setInfo(prev => ({...prev,rw_end_date:dayjs(e).format('YYYY-MM-DD')}))}}
                    />
                </Form.Item>
                <Form.Item
                    wrapperCol={{offset:"5"}}
                >
                    <Button type='primary' htmlType='submit'>提交</Button>
                </Form.Item>
            </Form>
        </Main>
    )
}

export default TaskAdd